module.exports = __webpack_public_path__ + "img/saude-da-crianca.608a64a9.svg";